module.exports = __webpack_public_path__ + "img/t8.b5944245.jpg";